import { AlertType, AlertRecord, AlertInfo } from './Types';
import locale, { Locale } from "../utils/Locale";
import * as Config from '../config';
import * as AlertTypes from './alertTypes/';
export * from './Types';
export * as Types from './alertTypes/';
import { State } from "../status/Types";
    

/**
 * Returns specific alert class according to `type`.
 * @param type 
 * @returns 
 * @see getClass()
 */
export function findClass(type: AlertType) {
    return Object
            .values(AlertTypes)
            .find(item => Array.isArray(item.type)
                ? (item.type).includes(type) // Alert class might support multiple types
                : item.type === type
            )
    ;
}

/**
 * Resolves the appropriate alert class for the given alert,
 * creates an instance, and returns the result of its `getInfo()` method.
 *
 * @param alert The alert record to process.
 * @param config 
 * @param states 
 * @param timeZone Optional time zone that overrides the one defined by the internal locale (or the passed in `locale`)
 * @param customLocale Optional locale instance to use instead of the default locale.
 * @returns The generated alert information.
 */
export function getInfo(alert: AlertRecord, config: Config.AllConfig, states:State[], timeZone?: string, customLocale?: Locale): AlertInfo {
    const alertClass = getClass(alert.type);
    const alertClassInstance = new alertClass(alert, config, states, customLocale);
    return alertClassInstance.getInfo(timeZone);
    /*
    const generatorClass = findClass(alert.type)
    if (generatorClass) {
        // Calling child class's static getInfo()
        // It will instantiate itself (the child class) and call it's own getInfo()
        return generatorClass.getInfo(alert, config, states, timeZone);
    }
    // Calling base class's static getInfo()
    // It will instantiate itself (the base class) and call it's own getInfo()
    const alertInfo = AlertTypes.AlertLogic.getInfo(alert, config, states, timeZone);
    return alertInfo;
    */
}

/**
 * Returns the alert class associated with the specified type.
 * Falls back to the base alert class if no matching class is found.
 * @param type The alert type.
 * @returns The corresponding alert class or the base alert class.
 * @see findClass()
 */
export function getClass(type: AlertType) {
    const generatorClass = findClass(type);
    if (generatorClass) {
        return generatorClass;
    }
    return AlertTypes.AlertLogic;
}

export function mock(type:AlertType, config:Config.AllConfig, subType?:string): AlertRecord[] | null {
    const generatorClass = getClass(type);
    
    const mocked = generatorClass.mock(type, config, subType);
    if (Array.isArray(mocked)) {
        return mocked;
    } else if (mocked) {
        return [ mocked ];
    }

    return null;

}

export function localFromRecord(alert:AlertRecord) {
    let rec = {
        UUID: alert.uuid,
        Created: new Date(alert.created),
        Type: alert.type,
        Data: alert.data,
        ItemID: alert.entityUuid,
        BodyOfWaterUUID: alert.bodyUuid,
        State: alert.state
    };

    return rec;
}
export function recordFromLocal(alert):AlertRecord {
    let rec = new AlertRecord({
        uuid: alert.UUID,
        created: new Date(alert.Created),
        type: alert.Type,
        data: alert.Data,
        entityUuid: alert.ItemID || alert.ItemId,
        bodyUuid: alert.BodyOfWaterUUID,
        state: alert.State,
    });

    return rec;
}